import React from 'react';
import { withTranslation } from 'react-i18next';
import { observer, inject } from 'mobx-react';
import style from './style.module.css';
import Modal from 'react-modal';
import Spinner from '../../../Spinner';

@inject(store => {
    const { myShopApiStore, ifaceMngr } = store;
    return { myShopApiStore, ifaceMngr };
})

@observer
class APILoader extends React.Component {
    constructor(props) {
        super(props);
        this.modalStyle = {
            content : {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                // display: 'flex',
                // justifyContent: 'center',
                // alignItems: 'center',
                width: '100%',
                height: '100%',
                backgroundColor: "rgb(255, 255, 255, 0.5)",
                
            },
            overlay: {
                backgroundColor: "rgb(255, 255, 255, 0)",
                zIndex: 200
            }
        }
        Modal.setAppElement('body');
    }
    
    render() {
        const { modalIsOpen } = this.props;
        const { t } = this.props;

        return (
            <Modal style={this.modalStyle} isOpen={modalIsOpen} >
                <div className={style.ModalContainer}>
                    <div className={style.SpinnerIcon}>
                        <Spinner loading={modalIsOpen} color="#000033" loader="RingLoader"/>
                    </div>
                    <div className={style.Content}>
                        <span>{t('wait for the operation complete')}...</span>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default withTranslation()(APILoader);